import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import styled from "styled-components";

import { inertMaterials, selectableElements } from "./elements.js";
import InputField from "../../ui/form/InputField";
import { Select } from "../../ui/form/formstyles";

const Label = styled.label`

`;

const CenteredSelect = styled(Select)`
    text-align-last: center;
    text-align: center;
`;

const Option = styled.option`

`;

const ElementSelect = ({ element, onChange, ...rest }) => {

    const displayName = (element) => `${element.name} @ ${element.pricePerUnit} UEC per unit`;

    const selectOptions = selectableElements
        .map((e) =>
            <Option
                key={e.id}
                value={e.id}
            >
                {displayName(e)}
            </ Option>
        );

    const isInertMaterials = element.elementId === inertMaterials.id;

    const handleChange = (e) => {
        const selectedId = e.target.value;
        if (!selectedId)
            return;

        const selectedElement = selectableElements.find((selectableElement) => selectableElement.id == selectedId);
        const elementCopy = {
            ...element,
            ...selectedElement,
            id: element.id,
            elementId: selectedElement.id
        };
        onChange(elementCopy);
    };

    if (isInertMaterials)
        return (
            <InputField
                value={displayName(element)}
                disabled={true}
            />
            );

    return (
        <CenteredSelect
            value={element.elementId}
            onChange={handleChange}
            autoFocus
            {...rest}
        >
            <Option>
                - Select element -
            </Option>
            {selectOptions}
        </ CenteredSelect>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
    };
};

const mapDispatchToProps = {
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ElementSelect));